import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ThemeProvider from "./components/feature/ThemeProvider";
import MotionPreferenceProvider from "./components/feature/MotionPreferenceProvider";
import InstallAppPrompt from "./components/feature/InstallAppPrompt";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <MotionPreferenceProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
            <InstallAppPrompt />
          </BrowserRouter>
        </MotionPreferenceProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
